var _module_exports = "<span>You are set as \"Unavailable\".</span>\n";;
var path = 'views/flashes/unavail_persistant.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;